import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../app/store";
import { PageState, RedirectToken } from "../api/Types";
import { getRedirect } from "../api/SwyftApi";
import { history } from "../app/rootReducer";

interface RedirectState {
  pageState: PageState;
  token?: string | null;
  redirectToken: RedirectToken | null;
  error: string | null;
}

const initialState: RedirectState = {
  pageState: PageState.Loading,
  token: null,
  redirectToken: null,
  error: null
};

function startLoading(state: RedirectState) {
  state.pageState = PageState.Loading;
}

function loadingFailed(state: RedirectState, action: PayloadAction<string>) {
  state.pageState = PageState.Error;
  state.error = action.payload;
}

const redirectToken = createSlice({
  name: "redirect",
  initialState,
  reducers: {
    getRedirectTokenStart: startLoading,
    getRedirectTokenSuccess(state, { payload }: PayloadAction<RedirectToken>) {
      state.pageState = PageState.Ready;
      state.token = payload.token;
      state.redirectToken = payload;
      state.error = null;
    },
    getRedirectTokenFailure: loadingFailed
  }
});

export const { getRedirectTokenStart, getRedirectTokenSuccess, getRedirectTokenFailure } = redirectToken.actions;

export default redirectToken.reducer;

export const fetchRedirectToken =
  (token: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getRedirectTokenStart());
      const redirectToken = await getRedirect(token);
      dispatch(getRedirectTokenSuccess(redirectToken));

      if (redirectToken.type === "QUOTE") {
        history.push(`/quote/${redirectToken.entityId}`);
      } else if (redirectToken.type === "PAYMENT") {
        history.push(`/payment/${redirectToken.entityId}`);
      }
    } catch (err: any) {
      dispatch(getRedirectTokenFailure(err.toString()));
    }
  };
